import { Button, List } from 'antd';
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect } from "react";
import { useStore } from "../../root-store-context";

export const WeekTable = observer(() => {
    const {
        userWeekStore: { catWeekList, isLoading, currentPage, getWeeksForUser, nextPage, prevPage },
        userWeeklyLogStore: { selectedCatWeek, setSelectedWeek }
    } = useStore();

    const [click, setClick] = React.useState(false);

    useEffect(() => { getWeeksForUser(); }, [])

    const getSundayOfPreviousWeek = () => {
        const today = new Date();
        return new Date(today.setDate(today.getDate() - today.getDay()));
    }

    useEffect(() => {}, [click])

    const renderListItem = (item: any) => {
        let bgColor = "#fccdcd";
        if (item.percentLoggedInSum < 99.9 && getSundayOfPreviousWeek().toDateString() == new Date(item.firstDayStr).toDateString()) {
            bgColor = "#fff8dd";
        } else if (item.percentLoggedInSum >= 99.9) {
            bgColor = "#ccfecf";
        }

        const isSelected = item.id == selectedCatWeek.id;

        return (
            <List.Item
                data-testid={`cat-row-week-${item.week}`}
                onClick={() => { setSelectedWeek(item); setClick(!click); }}
                style={{ backgroundColor: bgColor, cursor: "pointer", padding: "10px 16px" }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: 8 }}>
                    <span style={{ fontWeight: isSelected ? 600 : 400, whiteSpace: "nowrap" }}>
                        Week #{item.week}
                    </span>
                    <span style={{ color: "#1677ff", fontSize: 13, whiteSpace: "nowrap" }}>
                        {item.firstDayStr} - {item.lastDayStr}
                    </span>
                </div>
            </List.Item>
        );
    }

    return (
        <div className="cat-week-list">
            <span style={{ fontSize: 16, fontWeight: 600, padding: "0 4px" }}>Weeks</span>
            <div className="cat-week-list__border">
                <List
                    loading={isLoading}
                    size="small"
                    dataSource={Array.isArray(catWeekList) ? catWeekList : []}
                    renderItem={(item) => renderListItem(item)}
                />
            </div>
            <div className="cat-week-list__nav">
                <Button data-testid="cat-btn-week-prev" onClick={() => prevPage()} disabled={currentPage == 1 || isLoading}>◄</Button>
                <Button data-testid="cat-btn-week-next" onClick={() => nextPage()} disabled={isLoading}>►</Button>
            </div>
        </div>
    );
})